<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M46.3706 23.3925C46.305 23.2444 44.7169 19.7212 41.1862 16.1906C36.4819 11.4862 30.54 9 24 9C17.46 9 11.5181 11.4862 6.81373 16.1906C3.28311 19.7212 1.68748 23.25 1.62936 23.3925C1.54407 23.5843 1.5 23.7919 1.5 24.0019C1.5 24.2118 1.54407 24.4194 1.62936 24.6112C1.69498 24.7594 3.28311 28.2806 6.81373 31.8113C11.5181 36.5138 17.46 39 24 39C30.54 39 36.4819 36.5138 41.1862 31.8113C44.7169 28.2806 46.305 24.7594 46.3706 24.6112C46.4559 24.4194 46.5 24.2118 46.5 24.0019C46.5 23.7919 46.4559 23.5843 46.3706 23.3925ZM24 36C18.2287 36 13.1869 33.9019 9.01311 29.7656C7.30057 28.0626 5.84358 26.1205 4.68748 24C5.84327 21.8793 7.30029 19.9372 9.01311 18.2344C13.1869 14.0981 18.2287 12 24 12C29.7712 12 34.8131 14.0981 38.9869 18.2344C40.7027 19.9368 42.1629 21.8788 43.3219 24C41.97 26.5238 36.0806 36 24 36ZM24 15C22.22 15 20.4799 15.5278 18.9999 16.5168C17.5198 17.5057 16.3663 18.9113 15.6851 20.5558C15.0039 22.2004 14.8256 24.01 15.1729 25.7558C15.5202 27.5016 16.3773 29.1053 17.636 30.364C18.8947 31.6226 20.4983 32.4798 22.2442 32.8271C23.99 33.1743 25.7996 32.9961 27.4441 32.3149C29.0887 31.6337 30.4943 30.4802 31.4832 29.0001C32.4721 27.5201 33 25.78 33 24C32.9975 21.6138 32.0485 19.3261 30.3612 17.6388C28.6739 15.9515 26.3862 15.0025 24 15ZM24 30C22.8133 30 21.6533 29.6481 20.6666 28.9888C19.6799 28.3295 18.9108 27.3925 18.4567 26.2961C18.0026 25.1997 17.8838 23.9933 18.1153 22.8295C18.3468 21.6656 18.9182 20.5965 19.7573 19.7574C20.5965 18.9182 21.6656 18.3468 22.8294 18.1153C23.9933 17.8838 25.1997 18.0026 26.2961 18.4567C27.3924 18.9108 28.3295 19.6799 28.9888 20.6666C29.6481 21.6533 30 22.8133 30 24C30 25.5913 29.3678 27.1174 28.2426 28.2426C27.1174 29.3679 25.5913 30 24 30Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'WhiteOpenEyeIcon48'
};
</script>

<style scoped>

</style>
